import { Link } from "react-router-dom"
import { isNativeChurchCenterApp } from "source/Layout"
import { useChurchCenterIframe } from "source/shared/hooks/useChurchCenterIframe"

interface PostDonateSuccessLinksProps {
  orgWebsite?: string
  solicitAddress?: boolean
}

export function PostDonateSuccessLinks({
  solicitAddress = false,
  orgWebsite,
}: PostDonateSuccessLinksProps) {
  const { inIframe } = useChurchCenterIframe()

  if (isNativeChurchCenterApp() || inIframe) {
    return null
  }

  const isAppGuestMode = sessionStorage.getItem("app_guest_mode") === "true"

  return solicitAddress ? (
    <>
      {!isAppGuestMode && (
        <>
          <Link to="/me/profile/contact-and-info" className="btn">
            Add a mailing address
          </Link>
          <Link to="/giving/profile" className="btn badge-btn">
            View my giving
          </Link>
        </>
      )}
    </>
  ) : (
    <>
      {!isAppGuestMode && (
        <Link to="/giving/profile" className="btn">
          View my giving
        </Link>
      )}
      {orgWebsite && (
        <Link to={orgWebsite} className="btn badge-btn">
          Visit our website
        </Link>
      )}
    </>
  )
}
